var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShowPassword = function SvgIconShowPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.364 24C4.244 13.76 13.216 6 24 6s19.756 7.76 21.638 18C43.758 34.24 34.784 42 24 42S4.244 34.24 2.364 24M24 34a10 10 0 1 0 0-20 10 10 0 0 0 0 20m0-4a6 6 0 1 1 0-12 6 6 0 0 1 0 12"
  })));
};
export default SvgIconShowPassword;